var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 1.538)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 6.795,
    r: 2.667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.86 2.74c1.448.85 2.548 2.075 3.049 3.523l.067.195-.067.195c-.978 2.827-4.236 4.802-7.921 4.802a9.99 9.99 0 01-3.292-.551l.949-.948c.737.2 1.527.307 2.343.307 3.097 0 5.824-1.555 6.722-3.805-.472-1.183-1.45-2.173-2.72-2.847zM7.988 1.462c1.539 0 3.003.344 4.257.95l-.897.896a8.762 8.762 0 00-3.36-.655c-3.097 0-5.824 1.555-6.722 3.805.583 1.462 1.938 2.63 3.664 3.27l-.91.91C2.128 9.804.668 8.389.067 6.653L0 6.458l.067-.195c.978-2.827 4.236-4.801 7.921-4.801zm2.741 3.41A3.097 3.097 0 018.043 9.5 3.076 3.076 0 016.51 9.09l.894-.894a1.903 1.903 0 002.431-2.43zm-2.686-1.56c.906 0 1.723.392 2.289 1.015l-.845.843a1.898 1.898 0 00-1.444-.665c-1.05 0-1.902.853-1.902 1.901 0 .577.258 1.095.666 1.444l-.844.844A3.086 3.086 0 014.95 6.406a3.097 3.097 0 013.094-3.093z",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.185 0l.943.943L2.815 12.257l-.943-.943z"
  }))));
}

export default SvgIconHide;